import React, { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from './ModalDialog';

import { dialogMessageUpdated } from '../../actions';

import styles from './DialogMessage.module.css';

/**
 * As simple as a dialog message, nothing fancy.
 */
const DialogMessage = () => {
  const { t } = useTranslation('common');
  const store = useSelector(({ common }) => ({
    common,
  }), shallowEqual);
  const { common } = store;
  const { message, title, visible } = common.dialogMessage;
  const dispatch = useDispatch();

  const titleText = useMemo(() => title || t('errorModal.title'), [t, title]);

  const messageText = useMemo(
    () => message || t('errorModal.message'),
    [message, t],
  );

  const onClose = useCallback(() => {
    dispatch(dialogMessageUpdated({ visible: false }));
  }, []);

  return (
    <ModalDialog cancelable onClose={onClose} show={visible}>
      <div className={styles.mainContainer}>
        <h1>{titleText}</h1>

        <span>{messageText}</span>
      </div>
    </ModalDialog>
  );
};

const DialogMessageMemo = React.memo(DialogMessage);

export { DialogMessageMemo as DialogMessage };
